<template>
  <div class="collapseItem">
      <div class="collapseItemTitle" @click="select" :class="isdisabled">
          {{title}}
      </div>
      <div class="collaspeItemContent" v-if="isSelected">
        <slot></slot>
    </div>
  </div>
  
</template>

<script>
export default {
    name: 'g-collapse-item',
    props: {
        name: {
            type: String | Number,
            default:''
        },
        title: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            activeArr: [],
            isSingle: false
        }
    },
    inject: ['EventBus'],
    created() {
        this.EventBus.$on('collapseChange', (activeArr)=> {
            if(this.activeArr == activeArr) {
                return
            }
            this.activeArr = activeArr
        })
    },
    computed: {
        isSelected() {
            return this.activeArr.indexOf(this.name) >= 0
        },
        isdisabled() {
            return {
                disabled: this.disabled
            }
        }
    },
    methods: {
        select() {
            if(this.disabled){return}
            if(this.isSingle) {
                if(this.activeArr.indexOf(this.name) >=0){
                    this.activeArr = []
                }else{
                    this.activeArr = [this.name]
                }
            }else {
                if(this.activeArr.indexOf(this.name) >=0){
                    this.activeArr.splice(this.activeArr.indexOf(this.name),1)
                }else{
                    this.activeArr.push(this.name)
                }
            }
            this.EventBus.$emit('collapseChange', this.activeArr)
        }
    }
}
</script>

<style scoped lang="scss">
@import '../var';
.collapseItem{
    >.collapseItemTitle{
        cursor: pointer;
        border:1px solid $grey;
        margin:-1px;
        margin-bottom:0;
        padding:0 8px;
        display: flex;
        align-items: center;
        min-height:32px;
        &.disabled{
            color:#ccc;
            cursor: not-allowed;
        }
        
    }
    &:first-child {
        >.collapseItemTitle{
            border-top-left-radius: $border-radius;
            border-top-right-radius:$border-radius;
        }
    }
    &:last-child {
        >.collapseItemTitle:last-child{
            border-bottom:none;
            border-bottom-left-radius: $border-radius;
            border-bottom-right-radius:$border-radius;
        }
    }
    .collaspeItemContent{
        padding:8px;
    }
}

</style>